module.exports = __webpack_public_path__ + "static/media/madecraft_logo.2b6b0573.png";